import { Modal } from "@monolith-forensics/monolith-ui";
import { CreatePreservationForm } from "../Forms";
import { useCaseContext } from "@/Features/Cases";

export const CreatePreservationModal = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}: {
  show: boolean;
  onClose: () => void;
  onSubmit?: () => void;
  onCancel?: () => void;
}) => {
  const caseContext = useCaseContext();
  const defaultFormData = { case_id: caseContext?.data?.case_id || 0 };

  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };
  return (
    <Modal open={show} onClose={onClose}>
      <CreatePreservationForm
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        defaultFormData={defaultFormData}
      />
    </Modal>
  );
};
